import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { CREATE_APP_SUBSCRIPTION_RESOURCE } from '../../constants';

const CreateAppSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_APP_SUBSCRIPTION_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.organisationApps(),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createAppSubscriptionFailed'),
            onSuccessMessage: t('createAppSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateAppSubscriptionService;
